const expandCustomListHits = (hits, listId) => {
  const items = [];

  (hits || []).forEach((hit, hitIndex) => {
    const productId = Number(hit?.product_id ?? hit?.objectID);
    if (!Number.isFinite(productId)) {
      return;
    }

    (hit.custom_lists || []).forEach(entry => {
      if (!entry || entry.list_id !== listId) {
        return;
      }

      items.push({
        productId,
        // clickedObjectIDsAfterSearch wants the hit's place in this response,
        // the same value category cards send as __position. Cards from one
        // hit share it. Merchandising order lives on `position`.
        hitPosition: hitIndex + 1,
        position: Number(entry.position) || 0,
        optionSku: entry.option_sku || '',
        selectedOptions: Array.isArray(entry.selected_options)
          ? entry.selected_options
          : [],
        categorySlug: entry.category_slug || '',
      });
    });
  });

  items.sort((left, right) => left.position - right.position);
  return items;
};

export default expandCustomListHits;
